
import { granjaApi } from "../../api";
import { useCentroCostoStore } from "../../store";
import Swal from "sweetalert2";






export const startCentroXID = async(id) => {
    try {
        if( id === 'new') return null;
        const { data } = await granjaApi.get(`/cencos/xid/${id}`);
        return data.data;
    } catch (error) {
        console.log(error)
        Swal.fire('Error', error.response.data.msg, 'error');
    }
}




export const listadoCentrosSelect = async() => {
    try {
        const { data } = await granjaApi.get('/cencos/select');
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const startListadoCentros = async({ page=0, termino='' }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);

        const { data } = await granjaApi.get('/cencos/todos', { params });
        // useItemspagoStore.setState({ totalItemsPago: data.total });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}




export const startEstadoCentroCosto = async(id) => {
    try {
        await granjaApi.get(`/cencos/estado/${id}`);
        Swal.fire('Exitoso', 'Estado Actualizado', 'success');
        return true;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}





export const startSavingCentros = async(centro) => {
    try {
        if( centro.id ){
            await granjaApi.put(`/cencos/${centro.id}`, centro);
            Swal.fire('Exitoso', 'Centro de costo Actualizado', 'success');
        }else {
            await granjaApi.post('/cencos/new', centro);
            Swal.fire('Exitoso', 'Centro de costo Creado', 'success');
        }
        return true;
    } catch (error) {
        const msg = error?.response?.data?.errors?.[0]?.msg || error?.response?.data?.msg || 'Ocurrió un error inesperado';
        Swal.fire('Error', msg, 'error');
        return false;
    }
} 




export const startListConsumoCentro = async({ page=0, termino='', id }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);
        params.append('id',  id);

        const { data } = await granjaApi.get('/cencos/consumos', { params });
        useCentroCostoStore.setState({ totalesCentros: data.totales });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        throw new Error(errores);
    }
}
